import { Button, Grid, VStack } from '@hover/blueprint';
import { chakra } from '@hover/blueprint/chakra';
import React from 'react';

import { useHomeownerAppContext } from 'src/modules/homeownerApp/hooks';
import { HomeownerAppMenuNames } from 'src/modules/homeownerApp/providers/HomeownerAppProvider';
import { TranslationNamespace, useTranslate } from 'src/shared/hooks';

import desktop from 'assets/video/desktop-projects-landscape.mp4';
import mobilePortrait from 'assets/video/mobile-projects-portrait.mp4';

import { Footer } from '../../Footer';
import { desktopNavbarHeight } from '../../Navbar';

import { ProjectsHeading } from './ProjectsListHeading';

const Video = chakra('video', {
  baseStyle: {
    width: '100%',
    borderRadius: { tablet: '300' },
  },
});

const EmptyProjectsList = ({ loggedIn = false }: { loggedIn?: boolean }) => {
  const { setCurrentMenu } = useHomeownerAppContext();
  const t = useTranslate(TranslationNamespace.HOMEOWNER_APP);
  const [text, subText] = loggedIn
    ? [t('projects.projects'), t('projects.numProjects', { count: 0 })]
    : [t('projects.getItDone'), t('projects.loginPrompt')];

  return (
    <VStack
      minHeight={`calc(100vh - ${desktopNavbarHeight}px)`}
      px={{ tablet: '800' }}
    >
      <Grid
        gap="500"
        gridTemplateColumns={{ tablet: '1fr 2fr', base: '1fr' }}
        marginTop="800"
        width="100%"
      >
        <VStack alignItems="start" p={{ base: '500', tablet: '0' }}>
          <ProjectsHeading
            mb="600"
            subText={subText}
            text={text}
            width="334px"
          />
          {!loggedIn && (
            <Button
              onClick={() => setCurrentMenu(HomeownerAppMenuNames.SIGN_IN)}
            >
              {t('projects.signUpOrLogIn')}
            </Button>
          )}
        </VStack>
        <Video
          autoPlay
          display={{ tablet: 'none' }}
          loop
          muted
          playsInline
          src={mobilePortrait}
        />
        <Video
          autoPlay
          display={{ base: 'none', tablet: 'block' }}
          loop
          muted
          playsInline
          src={desktop}
        />
      </Grid>
      {!loggedIn && <Footer theme="dark" />}
    </VStack>
  );
};

export { EmptyProjectsList };
